module.exports = __webpack_public_path__ + "img/team-4.fe5dd38.webp";